import { getFilters } from 'lib/apiClient';
import { BrandCode, Locale } from 'lib/config/config';
import useSWR, { Fetcher } from 'swr';

function createCacheKey(locale: Locale): string {
	return `filters-${locale.country}-${locale.language}`;
}

export function useFiltersApi(locale: Locale, brand: BrandCode, fallbackData?: Array<unknown> | []) {
	const fetcher: Fetcher<Array<unknown>, string> = async () => {
		return getFilters(locale, brand);
	};

	return useSWR(createCacheKey(locale), fetcher, { fallbackData });
}
